var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Aside',{attrs:{"id":"asideVideo","ativo":_vm.$store.state.asideVideo != null},on:{"close":function($event){return _vm.close()}}},[_c('video',{attrs:{"src":_vm.$store.state.asideVideo,"controls":"","autoplay":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }